import { Request } from './Request';

export interface IGetNumExcessRevisionsParams {
  limit: number;
}

export interface IGetNumExcessRevisionsResult {
  workbookRevisionCount: number;
  datasourceRevisionCount: number;
  flowRevisionCount: number;
}

export class GetNumExcessRevisionsRequest extends Request<IGetNumExcessRevisionsParams, IGetNumExcessRevisionsResult> {
  constructor(params: IGetNumExcessRevisionsParams) {
    super('getNumExcessRevisions', params);
  }
}
